export default __webpack_public_path__ + "static/media/blue_bg.bcfe62ed.png";